import classnames from 'classnames';
import React from 'react';

import styles from './icon.module.scss';

export interface Props
  extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'height' | 'width' | 'src' | 'title'> {
  height: string;
  icon: string;
  width: string;
}

const Icon: React.FC<Props> = ({ alt, icon, className, ...props }) => (
  <img
    className={classnames(styles.base, className)}
    src={`https://static.policygenius.com/svgs/${icon}.svgz`}
    alt={alt ?? ''}
    title={icon}
    {...props}
  />
);

export default Icon;
